<template>
  <main>
    <Header />
    <slot />
    <Footer />
  </main>
</template>

<script>
import Header from '~/components/header/index.vue'
import Footer from '~/components/footer/index.vue'

export default {
  name: 'Default',
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped></style>
